var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcCaretRightRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 27,
    viewBox: "0 0 16 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#B82B27",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1321 3773L1333.5 3760 1346 3773",
    transform: "translate(-1326 -3753) rotate(90 1333.5 3766.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCaretRightRed);
export default __webpack_public_path__ + "static/media/ic-caret-right-red.43ba158275984e33490011a35c1c5729.svg";
export { ForwardRef as ReactComponent };